import { combineReducers } from 'redux';
import statistics from './TableStatistics/reducer';
import referredPartnersIndex from './ReferredPartnersIndex/reducer';
import referredPartnersShow from './ReferredPartnersShow/reducer';

import { HIDE_TOOLTIP } from '../reducer';
export const SHOW_TOOLTIP = 'Partners/SHOW_TOOLTIP';

export const showTooltip = activeTooltip => ({
  type: SHOW_TOOLTIP,
  activeTooltip
});

const initialState = { activeTooltip: '' };

const indexReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.activeTooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: ''
      };

    default:
      return state;
  }
};

const referredPartners = combineReducers({
  index: referredPartnersIndex,
  show: referredPartnersShow
});

export default combineReducers({
  index: indexReducer,
  statistics,
  referredPartners
  // commissionDue,
  // commissionPaid
});
